import { ImageActionType } from './image-action-type';
import { castArray } from 'lodash';

export interface UploadImageErrorAction {
  imageKey: string;
  errors: Error[];
  type: ImageActionType.UploadError;
}

export const uploadImageError = (
  imageKey: string,
  errors: Error | readonly Error[],
): UploadImageErrorAction => ({
  errors: castArray(errors),
  imageKey,
  type: ImageActionType.UploadError,
});
